import { list } from './_duck'
import * as types from './types'

export const getListRequest = list.createAction(types.LIST_GET_REQUEST)
export const getListSuccess = list.createAction(types.LIST_GET_SUCCESS)
export const getListFailure = list.createAction(types.LIST_GET_FAILURE)
